import { doc, getDoc, onSnapshot, setDoc } from 'firebase/firestore';

import { db } from '~/config/firebase.config';

/**
 * Option « Laisser chaque joueur choisir sa langue » d'un établissement (Mon compte).
 *
 * Rangée dans `clients/{id}/public/gamepadSettings.languagePicker`, PAS dans
 * `clients/{id}` : le téléphone du joueur (non connecté) ne peut lire que le
 * sous-dossier `public` (règles Firestore, dépôt unboared-b2b : lecture libre,
 * écriture réservée aux membres du lieu). Document à part plutôt que
 * `public/userData` : là-bas chaque booléen à `true` devient un champ demandé au
 * joueur sur l'écran du pseudo.
 *
 * Absent = éteint (défaut).
 */
const ref = (clientID: string) => doc(db, 'clients', clientID, 'public', 'gamepadSettings');

/** Lecture unique par le téléphone. `undefined` si illisible (réseau) : l'appelant garde l'état « inconnu ». */
export async function readVenueLanguagePicker(clientID: string): Promise<boolean | undefined> {
    try {
        const snap = await getDoc(ref(clientID));
        return snap.data()?.languagePicker === true;
    } catch (error) {
        console.error('Failed to load venue language picker setting:', error);
        return undefined;
    }
}

/** Suivi en direct pour Mon compte. */
export function subscribeVenueLanguagePicker(
    clientID: string,
    onChange: (enabled: boolean) => void,
    onError?: (error: unknown) => void
) {
    return onSnapshot(ref(clientID), (snap) => onChange(snap.data()?.languagePicker === true), onError);
}

export function writeVenueLanguagePicker(clientID: string, enabled: boolean) {
    return setDoc(ref(clientID), { languagePicker: enabled }, { merge: true });
}
